

export const en = {
  common: {
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
      preview: "Preview",
    generate: "Generate",
    reset: "Change Password",
    invalid: "Invalid File"
  },
  auth: {
     email: "Email",
    pwd: "Password",
    login: "Sign in",
    logout: "Log out",
    welcome: "Welcome, {name}!",
  },

  ui: {
     searchorder:"Search Event...",
   excludeorders:"Show past events",
error: "Error",
main: "Main Settings",
branding: "Branding",
access: "Access",
features: "Features",
links: "Links",
variables: "Text Variables",
events: "Events",
calendar: "Calendar",
urlshortener: "URL Shortener",
datadeleted: "Data deleted",
whatInformationDoYouWantToDelete: "What information do you want to delete?",
deleteEntireEvent: "!!! DELETE ENTIRE EVENT !!!",
deleteEventData: "Delete Event Data",
  }
} as const;